import { useEffect } from 'react';

import { useOrganValidationStore } from '@/store';

import { NECK_ORGAN, NECK_SUB_ORGAN } from './nav-menu.constant';

export function useUpdateSubOrganStatus(linkKey: string, subOrganLink: null | string[]) {
  const { getStatus, setStatus } = useOrganValidationStore();

  useEffect(() => {
    if (linkKey === NECK_ORGAN && subOrganLink) {
      const allSubOrgansDone = NECK_SUB_ORGAN.every((subOrgan) => {
        const status = getStatus(subOrgan);

        return status?.done && !status?.error && !status?.warning;
      });

      const currentNeckStatus = getStatus(NECK_ORGAN);

      if (
        allSubOrgansDone &&
        (!currentNeckStatus?.done || currentNeckStatus?.error || currentNeckStatus?.warning)
      ) {
        setStatus(NECK_ORGAN, { done: true, error: false, warning: false });
      } else if (
        !allSubOrgansDone &&
        (currentNeckStatus?.done || currentNeckStatus === undefined)
      ) {
        setStatus(NECK_ORGAN, { done: false, error: false, warning: false });
      }
    }
  }, [linkKey, subOrganLink, getStatus, setStatus]);
}
